import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IdentityStorage } from '../_models/identity.storage';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { Identity } from '../_models/identity';
import { LocalStorageService } from 'angular-web-storage';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UsuarioService } from '../../service/usuario/usuario.service';
import { map, catchError } from 'rxjs/operators';
import { AuthResult } from '../auth.result';

class UserPerfilResponse {
    public nome: string;
    public descricao: string;
    public email: string;
    public comarca: string;
    public lotacao: string;
    public cargo: string;
    public cpf: string;
}
class UserDataResponse {
    public id: string;
    public nome: string;
    public perfis: UserPerfilResponse[];
}
export class AuthenticationResponse {
    public descCargo: string;
    public email: string;
    public matricula: string;
    public nome: string;
    public token: string;
    public status: string;
    public perfil: string;
}

class AuthenticationResult {
    ok: boolean;
    message: string;

    constructor(ok: boolean, message: string) {
        this.ok = ok;
        this.message = message;
    }
}

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    baseUrl = environment.url;

    private messageSource = new BehaviorSubject(false);
    private loginSubject: BehaviorSubject<AuthenticationResponse>;
    public loginObs: Observable<AuthenticationResponse>;

    public message = this.messageSource.asObservable();

    constructor(
        private http: HttpClient,
        private usuarioService: UsuarioService,
        public identityStorage: IdentityStorage,
        public local: LocalStorageService,
        private router: Router,
        private toasterService: ToastrService,
    ) {
        this.loginSubject = new BehaviorSubject<AuthenticationResponse>(null);
        this.loginObs = this.loginSubject.asObservable();
    }

    public get userValue(): AuthenticationResponse {
        return this.loginSubject.value;
    }

    authenticate(login: string, password: string): Observable<AuthenticationResult> {
        const credentials = { matricula: login, senha: password };

        return this.http.post<AuthenticationResponse>(`${this.baseUrl}api/v1/auth/login`, credentials)
            .pipe(
                map(resp => {
                    if (resp.token) {
                        this.loginSubject.next(resp);
                        //this.identityStorage.saveAuthData(resp);
                        this.identityStorage.saveTokenInit(resp);
                        this.messageSource.next(true);
                        return new AuthenticationResult(true, null);
                    } else {
                        this.messageSource.next(false);
                        return new AuthenticationResult(false, 'Login ou Senha Inválidos');
                    }
                }),
                catchError(error => {
                    this.messageSource.next(false);
                    return of(new AuthenticationResult(false, error.message));
                })
            );
    }

    isExpired() {
        this.usuarioService.sessao().subscribe(_ => { }, _ => {
            this.toasterService.error('A sessão expirou, por favor realize o login.');
            this.identityStorage.clearAuthData();
            this.router.navigate(['login']);
        });
    }

    getUserAuthData(): Identity {
        return this.identityStorage.getUserAuthData();
    }

    getUserinit(): Identity {
        return this.identityStorage.getUserInit();
    }

    isAuthenticated(): boolean {
        return this.identityStorage.authenticationPresent();
    }

    isInitAuthenticated(): boolean {
        return this.identityStorage.authenticationInitPresent();
    }

    clearAuthentication(): void {
        this.identityStorage.clearAuthData();
    }

    saveAuthData(){
        this.loginObs.subscribe( resp => {
            this.identityStorage.saveAuthData(resp);
        })
    }

    getPerfis(perfis: Array<UserPerfilResponse>) {
        let perfilArray = '';
        if (perfis != null) {
            perfis.forEach(element => {
                perfilArray += element.nome + ',';
            });
        }
        return perfilArray;
    }

    isAdminSistema(): boolean {
        let retorno = false;
        this.getUserAuthData().perfil.split(',').forEach(element => {
            if (element === 'ADMINISTRADOR') {
                retorno = true;
            }
        });
        return retorno;
    }
}
